<template>
  <b-modal
    :id="modalId"
    :title="pacote ? pacote.titulo : 'Novidades do Sistema'"
    size="lg"
    centered
    scrollable
    hide-footer
    @hidden="$emit('fechar')"
  >
    <div v-if="pacote">
      <!-- Cabeçalho do pacote -->
      <div class="d-flex align-items-center mb-4">
        <span style="font-size: 32px; line-height: 1; margin-right: 12px;">🚀</span>
        <div>
          <p class="text-muted mb-1" v-if="pacote.descricao_curta">
            {{ pacote.descricao_curta }}
          </p>
          <div class="d-flex flex-wrap" style="gap: 8px;">
            <span class="label label-inline label-light-primary font-weight-bold" v-if="pacote.versao">
              Versão {{ pacote.versao }}
            </span>
            <span class="label label-inline label-primary font-weight-bold" v-if="pacote.data_publicacao">
              📅 {{ $moment(pacote.data_publicacao).format('DD/MM/YYYY') }}
            </span>
            <span class="label label-inline label-light-success font-weight-bold" v-if="pacote.itens && pacote.itens.length">
              {{ pacote.itens.length }} {{ pacote.itens.length === 1 ? "novidade" : "novidades" }}
            </span>
          </div>
        </div>
      </div>

      <hr class="mb-5" />

      <!-- Lista de itens -->
      <div
        v-for="(item, index) in pacote.itens"
        :key="index"
        class="d-flex mb-6"
      >
        <div class="mr-4 mt-1">
          <span
            class="label label-xl label-inline font-weight-bold"
            :class="tipoBadgeClass(item.tipo)"
            style="min-width: 110px;"
          >
            {{ tipoLabel(item.tipo) }}
          </span>
        </div>
        <div class="flex-grow-1">
          <h6 class="font-weight-bolder text-dark mb-1">{{ item.titulo }}</h6>
          <p class="text-muted font-size-sm mb-2" v-if="item.descricao_curta">
            {{ item.descricao_curta }}
          </p>
          <div class="d-flex flex-wrap" style="gap: 8px;" v-if="item.video_url || item.documentacao_url">
            <a
              v-if="item.video_url"
              :href="item.video_url"
              target="_blank"
              rel="noopener noreferrer"
              class="btn btn-sm btn-light-primary font-weight-bold"
            >
              ▶ Ver vídeo
            </a>
            <a
              v-if="item.documentacao_url"
              :href="item.documentacao_url"
              target="_blank"
              rel="noopener noreferrer"
              class="btn btn-sm btn-light-info font-weight-bold"
            >
              📄 Documentação
            </a>
          </div>
        </div>
      </div>

      <hr class="mt-4 mb-5" />

      <!-- Botões de ação -->
      <div class="d-flex justify-content-end" style="gap: 12px;">
        <button
          class="btn btn-light font-weight-bold"
          @click="verDepois"
        >
          Ver depois
        </button>
        <button
          class="btn btn-primary font-weight-bolder"
          :disabled="marcando"
          @click="marcarComoLido"
        >
          <b-spinner small v-if="marcando" class="mr-2" />
          Entendi (Não apresentar novamente)
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "ModalNovidades",
  props: {
    modalId: {
      type: String,
      default: "modal-novidades",
    },
    pacote: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      marcando: false,
    };
  },
  methods: {
    async marcarComoLido() {
      if (!this.pacote) return;
      this.marcando = true;
      try {
        await this.$http.post("/novidades/marcar-como-lido", { id: this.pacote.id });
      } catch (_) {
        // falha silenciosa — não bloquear o usuário
      } finally {
        this.marcando = false;
        this.$bvModal.hide(this.modalId);
        this.$emit("lido", this.pacote.id);
      }
    },

    verDepois() {
      this.$bvModal.hide(this.modalId);
      this.$emit("fechar");
    },

    formatDate(date) {
      if (!date) return "";
      return this.$moment(date).format("DD/MM/YYYY");
    },

    tipoLabel(tipo) {
      const map = {
        funcionalidade: "Nova função",
        melhoria: "Melhoria",
        correcao: "Correção",
        comunicado: "Comunicado",
        treinamento: "Treinamento",
        importante: "Importante",
      };
      return map[tipo] || tipo;
    },

    tipoBadgeClass(tipo) {
      const map = {
        funcionalidade: "label-light-success",
        melhoria: "label-light-primary",
        correcao: "label-light-warning",
        comunicado: "label-light-info",
        treinamento: "label-light-dark",
        importante: "label-light-danger",
      };
      return map[tipo] || "label-light-secondary";
    },
  },
};
</script>
